import React from 'react';
import {useSelector} from 'react-redux';

import {getLocalizedStrings} from '@/services/localization/localizationService';
import {selectIsAem} from '@/state/selectors/global';
import {twx} from '@/utils/tailwindUtils';

import RemoteIcon from '../Icon/RemoteIcon';

const ContentList = ({list, className, itemProps}) => {
    const isAem = useSelector(selectIsAem);
    const localizedStrings = getLocalizedStrings();

    return (
        <ul className={twx('flex w-full flex-col gap-4', className)}>
            {list?.map((icon) => {
                const {titleKey, descriptionKey} = icon;
                const title = localizedStrings[titleKey];
                const description = localizedStrings[descriptionKey];

                return (
                    <ItemTitle
                        key={titleKey}
                        title={title}
                        description={description}
                        icon={icon}
                        isAem={isAem}
                        {...itemProps}
                    />
                );
            })}
        </ul>
    );
};

const ItemTitle = ({title, description, icon, isAem, className, titleClassName, descriptionClassName}) => {
    return (
        <li
            className={twx(
                {grid: !isAem},
                {'gap-x-4': description},
                'grid-cols-[48px_1fr] items-center gap-x-2 text-16 leading-15 empty:hidden',
                className
            )}
        >
            {title && (
                <>
                    <div className='row-span-2 h-auto w-full shrink-0'>
                        <RemoteIcon icon={icon} />
                    </div>
                    <p
                        className={twx(
                            {'font-bold': description},
                            {'row-span-2': !description},
                            'content-center text-16 leading-15',
                            titleClassName
                        )}
                    >
                        {title}
                    </p>
                </>
            )}
            {description && <p className={descriptionClassName}>{description}</p>}
        </li>
    );
};

export default ContentList;
